import SplitType from 'split-type';
import gsap from 'gsap';
import './effects';
import Typewriter from 'typewriter-effect/dist/core';

export default class Animations {
    static init() {
        // Animations
        this.global();
        this.images();

        this.header();
        this.etude();
        this.studio();
        this.operation();
        this.references();
        this.footer();
    }

    static global() {
        const elts = gsap.utils.toArray(`
            .article .article__picto,
            .etude .article__cta .cta,
            .accordeon .accordeon__item,
            .studio .article__cta .cta,
            .introduction .introduction__cta,
            .reference__cta .cta
        `);

        if(elts.length > 0) {
            elts.forEach((elt) => {
                gsap.from(
                    elt,
                    {
                        scrollTrigger: {
                            trigger: elt,
                            start: 'top 80%'
                        },
                        opacity: 0,
                        y: 40,
                        rotate: 2,
                        ease: 'power4.out',
                        duration: 0.85,
                        onComplete: function onComplete() {
                            gsap.set(this.targets(), {
                                clearProps: 'all',
                            });
                        },
                    }
                );
            });
        }
    }

    static images() {
        const elts = gsap.utils.toArray('.images');

        elts.forEach((elt) => {
            gsap.from(
                elt.querySelectorAll('.images__item'),
                {
                    scrollTrigger: {
                        trigger: elt,
                        start: 'top 80%'
                    },
                    clipPath: 'polygon(0 100%, 100% 100%, 100% 100%, 0% 100%)',
                    ease: 'power4.out',
                    duration: 0.85,
                    stagger: -0.1,
                    onComplete: function onComplete() {
                        gsap.set(this.targets(), {
                            clearProps: 'all',
                        });
                    },
                }
            );

            gsap.from(
                elt.querySelectorAll('.images__img'),
                {
                    scrollTrigger: {
                        trigger: elt,
                        start: 'top 80%'
                    },
                    scale: 1.2,
                    duration: 0.7,
                    stagger: -0.1,
                    onComplete: function onComplete() {
                        gsap.set(this.targets(), {
                            clearProps: 'all',
                        });
                    },
                }
            );
        });
    }

    static header() {
        const header = document.querySelector('.header');
        if (header) {
            const tlHeader = gsap.timeline({
                scrollTrigger: {
                    trigger: header,
                    start: 'top 80%',
                },
            });

            if (header.querySelector('.header__title')) {
                tlHeader.displayElt(header.querySelectorAll('.header__title strong'));
                tlHeader.displayElt(header.querySelectorAll('.header__title span'), '>-90%');
            }

            if (header.querySelector('.textContainer.textContainer--centered')) {
                new SplitType(header.querySelector('.textContainer.textContainer--centered'), {
                    tagName: 'p'
                });

                tlHeader.displayElt(header.querySelectorAll('.textContainer.textContainer--centered > p'), '>-90%');
            }

            if (header.querySelector('.header__arrow')) {
                tlHeader.displayElt(header.querySelectorAll('.header__arrow'), '>-90%');
            }

            gsap.from(
                header.querySelector('.header__video'),
                {
                    scrollTrigger: {
                        trigger: header.querySelector('.header__video'),
                        start: 'top 80%'
                    },
                    clipPath: 'polygon(0 100%, 100% 100%, 100% 100%, 0% 100%)',
                    ease: 'power4.out',
                    duration: 0.85,
                    stagger: -0.1,
                    delay: 0.3,
                    onComplete: function onComplete() {
                        gsap.set(this.targets(), {
                            clearProps: 'all',
                        });
                    },
                }
            );

            if (header.querySelector('.introduction__title')) {
                new SplitType(header.querySelector('.introduction__title'), {
                    tagName: 'span'
                });

                gsap.from(
                    header.querySelectorAll('.introduction__title > span'),
                    {
                        scrollTrigger: {
                            trigger: header.querySelector('.introduction__title'),
                            start: 'top 80%',
                        },
                        opacity: 0,
                        y: 40,
                        rotate: 2,
                        ease: 'power4.out',
                        duration: 0.85,
                        stagger: 0.1,
                        onComplete: function onComplete() {
                            gsap.set(this.targets(), {
                                clearProps: 'all',
                            });
                        },
                    }
                );
            }

            if (header.querySelector('.introduction__content')) {
                new SplitType(header.querySelector('.introduction__content'), {
                    tagName: 'p'
                });

                gsap.from(
                    header.querySelectorAll('.introduction__content > p'),
                    {
                        scrollTrigger: {
                            trigger: header.querySelector('.introduction__content'),
                            start: 'top 80%',
                        },
                        opacity: 0,
                        y: 40,
                        rotate: 2,
                        ease: 'power4.out',
                        duration: 0.85,
                        stagger: 0.1,
                        onComplete: function onComplete() {
                            gsap.set(this.targets(), {
                                clearProps: 'all',
                            });
                        },
                    }
                );
            }

            if (header.querySelector('.introduction__service')) {
                gsap.from(
                    header.querySelectorAll('.introduction__service *'),
                    {
                        scrollTrigger: {
                            trigger: header.querySelector('.introduction__service'),
                            start: 'top 80%',
                        },
                        opacity: 0,
                        y: 40,
                        rotate: 2,
                        ease: 'power4.out',
                        duration: 0.85,
                        stagger: 0.1,
                        onComplete: function onComplete() {
                            gsap.set(this.targets(), {
                                clearProps: 'all',
                            });
                        },
                    }
                );
            }
        }
    }

    static etude() {
        const etude = document.querySelector('.etude');
        if (etude) {
            const tlEtude = gsap.timeline({
                scrollTrigger: {
                    trigger: etude.querySelector('.etude__title'),
                    start: 'top 80%',
                },
            });

            if (etude.querySelector('.etude__title')) {
                tlEtude.displayElt(etude.querySelectorAll('.etude__title strong'));
                tlEtude.displayElt(etude.querySelectorAll('.etude__title span'), '>-90%');
            }

            if (etude.querySelector('.textContainer.textContainer--centered')) {
                new SplitType(etude.querySelector('.textContainer.textContainer--centered'), {
                    tagName: 'p'
                });

                tlEtude.displayElt(etude.querySelectorAll('.textContainer.textContainer--centered > p'), '>-90%');
            }

            if (etude.querySelector('.etude__subTitle')) {
                new SplitType(etude.querySelector('.etude__subTitle'), {
                    tagName: 'span'
                });

                gsap.from(
                    etude.querySelectorAll('.etude__subTitle > span'),
                    {
                        scrollTrigger: {
                            trigger: etude.querySelector('.etude__subTitle'),
                            start: 'top 80%',
                        },
                        opacity: 0,
                        y: 40,
                        rotate: 2,
                        ease: 'power4.out',
                        duration: 0.85,
                        stagger: 0.1,
                        onComplete: function onComplete() {
                            gsap.set(this.targets(), {
                                clearProps: 'all',
                            });
                        },
                    }
                );
            }

            if (etude.querySelector('.etude__content')) {
                new SplitType(etude.querySelector('.etude__content'), {
                    tagName: 'p'
                });

                gsap.from(
                    etude.querySelectorAll('.etude__content > p'),
                    {
                        scrollTrigger: {
                            trigger: etude.querySelector('.etude__content'),
                            start: 'top 80%',
                        },
                        opacity: 0,
                        y: 40,
                        rotate: 2,
                        ease: 'power4.out',
                        duration: 0.85,
                        stagger: 0.1,
                        onComplete: function onComplete() {
                            gsap.set(this.targets(), {
                                clearProps: 'all',
                            });
                        },
                    }
                );
            }
        }
    }

    static studio() {
        const studio = document.querySelector('.studio');
        if (studio) {
            const tlStudio = gsap.timeline({
                scrollTrigger: {
                    trigger: studio.querySelector('.studio__title'),
                    start: 'top 80%',
                },
            });

            if (studio.querySelector('.studio__title')) {
                tlStudio.displayElt(studio.querySelectorAll('.studio__title strong'));
                tlStudio.displayElt(studio.querySelectorAll('.studio__title span'), '>-90%');
            }

            if (studio.querySelector('.textContainer.textContainer--centered')) {
                new SplitType(studio.querySelector('.textContainer.textContainer--centered'), {
                    tagName: 'p'
                });

                tlStudio.displayElt(studio.querySelectorAll('.textContainer.textContainer--centered > p'), '>-90%');
            }

            gsap.from(
                studio.querySelector('.studio__video'),
                {
                    scrollTrigger: {
                        trigger: studio.querySelector('.studio__video'),
                        start: 'top 80%'
                    },
                    clipPath: 'polygon(0 100%, 100% 100%, 100% 100%, 0% 100%)',
                    ease: 'power4.out',
                    duration: 0.85,
                    stagger: -0.1,
                    delay: 0.3,
                    onComplete: function onComplete() {
                        gsap.set(this.targets(), {
                            clearProps: 'all',
                        });
                    },
                }
            );

            if (studio.querySelector('.studio__content')) {
                gsap.from(
                    studio.querySelectorAll('.studio__content *'),
                    {
                        scrollTrigger: {
                            trigger: studio.querySelector('.studio__content'),
                            start: 'top 80%',
                        },
                        opacity: 0,
                        y: 40,
                        rotate: 2,
                        ease: 'power4.out',
                        duration: 0.85,
                        stagger: 0.1,
                        onComplete: function onComplete() {
                            gsap.set(this.targets(), {
                                clearProps: 'all',
                            });
                        },
                    }
                );
            }
            
            if(studio.querySelector('.studio__background')) {
                tlStudio.fadeIn(studio.querySelectorAll('.studio__background'), '>-90%');
            }
        }
    }

    static operation() {
        const operation = document.querySelector('.operation');
        if (operation) {
            const tlOperation = gsap.timeline({
                scrollTrigger: {
                    trigger: operation,
                    start: 'top 80%',
                },
            });

            if (operation.querySelector('.operation__title')) {
                new SplitType(operation.querySelector('.operation__title'), {
                    tagName: 'span'
                });

                tlOperation.displayElt(operation.querySelectorAll('.operation__title > span'), '>-90%');
            }

            if (operation.querySelector('.operation__picto')) {
                tlOperation.displayElt(operation.querySelectorAll('.operation__picto'), '>-70%');
            }
        }
    }

    static references() {
        const reference = document.querySelector('.reference');
        if (reference) {
            const sliders = gsap.utils.toArray('.reference__item');
            if(sliders.length > 0) {
                sliders.forEach((slider) => {
                    gsap.from(
                        slider,
                        {
                            scrollTrigger: {
                                trigger: slider,
                                start: 'top 80%'
                            },
                            opacity: 0,
                            y: 40,
                            rotate: 2,
                            ease: 'power4.out',
                            duration: 0.85,
                            onComplete: function onComplete() {
                                gsap.set(this.targets(), {
                                    clearProps: 'all',
                                });
                            },
                        }
                    )
                });
            }

            const elts = gsap.utils.toArray(`
                .reference__content .textContainer h2,
                .reference__content .textContainer h3,
                .reference__content .textContainer h4
            `);

            if(elts.length > 0) {
                elts.forEach((elt) => {
                    gsap.from(
                        elt,
                        {
                            scrollTrigger: {
                                trigger: elt,
                                start: 'top 80%'
                            },
                            opacity: 0,
                            y: 40,
                            rotate: 2,
                            ease: 'power4.out',
                            duration: 0.85,
                            onComplete: function onComplete() {
                                gsap.set(this.targets(), {
                                    clearProps: 'all',
                                });
                            },
                        }
                    );
                });
            }

            const paragraphs = gsap.utils.toArray('.reference__content .textContainer p');
            if(paragraphs.length > 0) {
                paragraphs.forEach((p) => {
                    gsap.from(
                        p,
                        {
                            scrollTrigger: {
                                trigger: p,
                                start: 'top 80%',
                            },
                            opacity: 0,
                            duration: 0.0001,
                            onComplete: function onComplete() {
                                gsap.set(this.targets(), {
                                    clearProps: 'all',
                                });

                                const typewriter = new Typewriter(p, {
                                    loop: false,
                                    delay: 30,
                                    cursor: '',
                                });

                                typewriter
                                    .pauseFor(150)
                                    .typeString(p.dataset.text)
                                    .start();
                            },
                        }
                    );
                });
            }
        }
    }

    static footer() {
        const footer = document.querySelector('.footer');
        if(footer) {
            document.body.style.paddingBottom = `${footer.offsetHeight - 20}px`;
        }
    }
}